module.exports = __webpack_public_path__ + "img/手淘搜索推送6.1eb58a17.gif";